import { render, staticRenderFns } from "./ConnectionCard.vue?vue&type=template&id=e1877cd0&scoped=true&"
import script from "./ConnectionCard.vue?vue&type=script&lang=js&"
export * from "./ConnectionCard.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionCard.vue?vue&type=style&index=0&id=e1877cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1877cd0",
  null
  
)

export default component.exports